import React, { useState } from 'react';
import Select from 'react-select';

const ChangeRoleModal = () => {
  // role data----------------------------------------------------------------
  const role = [
    { label: 'role 1', value: 'role 1' },
    { label: 'role 2', value: 'role 2' },
    { label: 'role 3', value: 'role 3' },
    { label: 'role 4', value: 'role 4' },
    { label: 'role 5', value: 'role 5' },
  ];

  const [selectRole, setSelectRole] = useState(null); // select role
  return (
    <div
      className="modal fade"
      id="changeRole"
      tabIndex="-1"
      aria-labelledby="changeRoleLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-header p-4 pb-0 border-0">
            <h2 className="fw-bold mb-0" id="changeRoleLabel">
              Change Role
            </h2>
            <button
              type="button"
              className="btn-close p-0 bg-gray-200 rounded-circle shadow-none m-0"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body p-4">
            <form action="">
              {/* ======= change role section ========= */}
              <div className="form-group mb-4">
                <label
                  htmlFor="changeRole"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  Change Role
                </label>
                <Select
                  className="form-select fs-sm shadow-none"
                  placeholder="Select label"
                  options={role}
                  value={selectRole}
                  onChange={val => {
                    setSelectRole(val);
                  }}
                />
              </div>

              {/* ====== submit section =========== */}
              <div className="action">
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangeRoleModal;
